<template>
  <div>
    <my-head></my-head>
    <div class="consult minH">
      <div class="crumbs">
        首页 > 运营服务 >
        <span style="color: #1d2129">IP咨询</span>
      </div>

      <div class="title">IP咨询</div>

      <div class="tabs flex-between">
        <div
          v-for="(item, index) in tablist"
          :key="index"
          :class="tab == item.id ? 'checked' : ''"
          @click="tab = item.id"
        >
          <img
            :src="item.icon1"
            class="col_img margin-auto"
            v-show="tab != item.id"
          />

          <img
            :src="item.icon"
            class="col_img margin-auto"
            v-show="tab == item.id"
          />

          <div class="col_title flex-center">{{ item.title }}</div>

          <div class="col_content" v-html="item.content"></div>
        </div>
      </div>

      <div class="title1">{{ tablist[tab - 1].title }}</div>

      <div class="jie_shao" v-html="tablist[tab - 1].jieshao"></div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      tablist: [
        {
          id: 1,
          title: "IP分析导航",
          content: "对专利信息进行加工、<br/>整理和分析",
          icon: require("../../assets/icon/consult_1_1.png"),
          icon1: require("../../assets/icon/consult_1_2.png"),
          jieshao: `专利分析是对专利信息进行加工、整理和分析，并利用统计学方法和技巧对这些信息进行深度挖掘和缜密剖析，使这些信息转化为具有总揽全局及预测功能的竞争情报，为企业的技术、产品及服务开发中的决策提供参考。 <br/>专利导航以专利信息资源利用和专利分析为基础，把专利运用嵌入产业技术创新、产品创新、组织创新和商业模式创新之中，通过专利导航探索建立专利信息分析与产业运行决策深度融合、专利创造与产业创新能力高度匹配,引导和支撑产业的科学发展，对于推动产业布局更加科学、产业结构更加合理，推动创新资源向产业发展的关键技术领域聚集，提升企业的竞争优势，具有重要的作用。`,
        },
        {
          id: 2,
          title: "IP管理咨询",
          content: "为企业知识产权管理提<br/>供全套解决方案",
          icon: require("../../assets/icon/consult_2_1.png"),
          icon1: require("../../assets/icon/consult_2_2.png"),
          jieshao: `IP管理咨询站在企业经营的角度，为企业知识产权管理提供全套解决方案。通过IP管理咨询，帮助企业建立和优化知识产权管理体系，以定制化的组织结构、制度、流程、标准和表单模板落地专利规划。`,
        },
        {
          id: 3,
          title: "IP贯标",
          content: "提供基于过程方法的企<br/>业知识产权管理模型",
          icon: require("../../assets/icon/consult_3_1.png"),
          icon1: require("../../assets/icon/consult_3_2.png"),
          jieshao: `知识产权贯标，即依据《企业知识产权管理规范》（GB/T 29490-2013），《科研组织知识产权管理规范》（GB/T 33250-2016）、《高等学校知识产权管理规范》（GB/T 33251-2016）等知识产权国家标准，提供基于过程方法的企业知识产权管理模型，指导企业策划、实施、检查、改进知识产权管理体系，提升企业、高校、科研院所等创新相关主体的知识产权管理能力。`,
        },
        {
          id: 4,
          title: "专利战略",
          content: "巨大市场需求，全球半<br/>导体产业关注焦点",
          icon: require("../../assets/icon/consult_4_1.png"),
          icon1: require("../../assets/icon/consult_4_2.png"),
          jieshao: `专利战略管理可以帮助企业制定专利战略规划，分析企业内外部环境、挑战和机会，定位专利价值观和战略目标，为各项知识产权决策与实施方案寻找出发点。其核心是对行业和竞争对手进行充分研究，用专利的工具实现对技术现状、技术走向和技术壁垒的总结，找到突破和实现领先的路径。`,
        },
        {
          id: 5,
          title: "技术人才专家库",
          content: "对知产专家人才做出科<br/>学、有效、统一的管理",
          icon: require("../../assets/icon/consult_5_1.png"),
          icon1: require("../../assets/icon/consult_5_2.png"),
          jieshao: `知识产权人才是从事知识产权工作，具有一定的知识产权专业知识和实践能力，能够推动知识产权事业发展并对激励创新、引领创新、保护创新和服务创新作出贡献的人，是发展知识产权事业和建设知识产权强国最基本、最核心、最关键的要素。<br/>知识产权人才专家库是为了对知识产权专家人才做出科学、有效、统一的管理，提供专家人才积极参与知识产权事业的平台，同时帮助公众快速、便捷的获取专家人才信息。`,
        },
      ],
      tab: 1,
    };
  },
};
</script>

<style lang="scss">
.consult {
  width: 80%;
  margin: 24px auto 60px;
  .jie_shao {
    font-size: 14px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
  }
  .title1 {
    margin-bottom: 32px;
    font-size: 20px;
    font-weight: bold;
    color: #1d2129;
    line-height: 28px;
  }
  .tabs {
    margin-bottom: 64px;
    & > div {
      width: 18%;
      padding: 24px 0;
      background: #f7f8fa;
      border-radius: 8px;
      border: 1px solid #e5e6eb;
      cursor: pointer;
      .col_content {
        font-size: 14px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
        text-align: center;
      }
      .col_title {
        margin-bottom: 8px;
        font-size: 18px;
        font-weight: 500;
        color: #1d2129;
        line-height: 26px;
      }
      .col_img {
        height: 31px;
        margin-bottom: 21px;
      }
    }
    .checked {
      background: #ffffff;
    }
  }
  .title {
    margin-bottom: 32px;
    font-size: 30px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
  }
}
</style>
